import { render } from "./QueryView.vue?vue&type=template&id=929befe2&scoped=true"
import script from "./QueryView.vue?vue&type=script&lang=js"
export * from "./QueryView.vue?vue&type=script&lang=js"

import "./QueryView.vue?vue&type=style&index=0&id=929befe2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929befe2"]])

export default __exports__